// The intake proxy forwards to this site's intake host and the client token
// only works on its own site, so the SDK and the proxy must resolve the same one.
export const datadogSite =
  process.env.NEXT_PUBLIC_DATADOG_SITE ?? "us5.datadoghq.com"
